export default __webpack_public_path__ + "static/media/Menu_Polo_W.c56ffc93.svg";